import { NavigationContainerRefWithCurrent } from '@react-navigation/native';
import { SCREEN_HEIGHT } from 'context/BottomSheetContext';
import { getDeviceTypeAsync } from 'expo-device';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Platform } from 'utils/platform';

import { LiveSheet } from './LiveSheet';

type LiveMenuProviderProps = {
  children: React.ReactNode;
  navigationRef?: NavigationContainerRefWithCurrent<any>;
};

const LiveMenuProvider: React.FC<LiveMenuProviderProps> = ({ children, navigationRef }) => {
  const [isSmallDevice, setIsMobile] = useState(false);

  useEffect(() => {
    getDeviceTypeAsync().then(async (deviceType: any) => {
      setIsMobile(deviceType === 1 || deviceType === 2);
    });
  }, []);

  const content = (
    <>
      {children}
      <LiveSheet navigationRef={navigationRef} />
    </>
  );

  if (!isSmallDevice) {
    return children;
  }

  return Platform.OS === 'web' ? (
    <View style={{ height: '100%', maxHeight: SCREEN_HEIGHT, overflow: 'hidden', zIndex: 3 }}>
      {content}
    </View>
  ) : (
    <>{content}</>
  );
};

export default LiveMenuProvider;
